
import { Options, mixins } from 'vue-class-component'
import { ITableColumn, TableUtils } from '@/utils/table'
import TableMixin from './mixins/TableMixin.vue'
import BaseTableComponent from './components/BaseTableComponent.vue'

@Options({
  name: 'CommonMessagesTable',
  components: {
    BaseTableComponent,
  },
})
export default class CommonMessagesTable extends mixins(TableMixin) {
  get columns(): ITableColumn[] {
    return [
      ...this.baseColumns,
      {
        name: 'delivered',
        label: this.$t('label.delivery_count'),
        field: 'delivered',
        align: 'right',
        format: TableUtils.formatNumber,
      },
      ...this.commonGoalColumns,
    ]
  }
}
